import clsx from "clsx"

type BaseOutlineTextType = {
    text?: string
    big?: boolean
    weight: string
    classProps?: string
    textSize?: string
    blockTextAnimation?: boolean
}

export default function BaseOutlineText(props: BaseOutlineTextType) {
    const outlineClass = clsx({
        "text-outline-slim": props.weight.includes("slim"),
        "text-outline-medium": props.weight.includes("medium"),
        "text-outline-thick": props.weight.includes("thick"),
        "text-outline-xthick": props.weight.includes("xthick"),
    })

    return (
        <div
            style={{
                fontFamily: "Arial, Verdana, Trebuchet MS, Tahoma, Helvetica "
            }}
            className={`text-secondary font-bold ${
                props?.big ? "text-[10rem]" : props?.textSize ? props.textSize : "text-7xl"
            } uppercase text-outline-thick ${outlineClass} ${props.classProps ?? "opacity-30 md:opacity-100 "}`}>
            {props?.text}
        </div>
    )
}
